export const ADMIN = 'admin';
export const MANAGER = 'manager';
export const DOCTOR = 'doctor';
export const USER = 'user';
